module.exports = __webpack_public_path__ + "static/media/recent-user-4.9c573831.png";